import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getProtocolEntries(protocolEntries) {
        await axios.get(requesturl() + "/api/latest/ProtocolEntry", {headers: {Authorization: window.$cookies.get("token")}})
            .then(res => {
                protocolEntries(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async getProtocolEntriesForUser(protocolEntries) {
        await axios.get(requesturl() + "/api/latest/ProtocolEntry/User", {headers: {Authorization: window.$cookies.get("token")}})
            .then(res => {
                protocolEntries(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/protocolentryinterface.js